import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { IconComponent } from '@mitsubishi/shared/ui';

import { FieldWrapper, FormlyField } from '@ngx-formly/core';

@Component({
  selector: 'apm-tab-wrapper',
  templateUrl: './tab-wrapper.component.html',
  styleUrls: ['./tab-wrapper.component.scss'],
  imports: [MatTabsModule, MatTabGroup, FormlyField, ApmTranslatePipe, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabWrapperComponent extends FieldWrapper {
  isValid(field: any) {
    if (field.key) {
      return field?.formControl?.valid;
    }
    return field?.every(f => this.isValid(f));
  }
}
